import type { Album } from '../../../../types'

/**
 * The caller's role on an album (SOL-185). The server decides it from the
 * Memoir's OWNER and sends it on every album it returns; `photographerId` is
 * who created the album and no longer says who may change it.
 *
 * A local temp album (`temp_*`) has no role because the server has never seen
 * it: it was made on this device by this user, so it is theirs. Any other
 * album without one is not treated as the caller's.
 */
export function albumRole(album: Pick<Album, 'uuid' | 'role'>): 'owner' | 'member' | null {
  if (album.role) return album.role
  return album.uuid.startsWith('temp_') ? 'owner' : null
}
